// extracted by mini-css-extract-plugin
export default {"svg":"Icon_svg__lIFcV","small":"Icon_small__MWGdP","medium":"Icon_medium__IwIw7","large":"Icon_large__m66wT"};